<template>
  <div style="min-height: 100vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container top-spacing colum">
      <div class="golf-good-price mb-10">
        <div class="top-post-container mb-10">
          <p class="fw-600 m-0 text-uppercase c-body">
            {{ title }}
          </p>
        </div>
        <!-- <p class="c-black-text c-bold-text title-h3 m-0">
          {{ title }}
        </p> -->
        <div class="d-flex justify-content-right mb-10">
          <div>
            <CountDownTime
              v-if="query.is_flash_sale == 1"
              :nameCountDown="name_count_down"
              :timeEndCountDown="+query.end_date_sale"
              :timeStartCountDown="+query.start_date_sale"
            />
          </div>
        </div>
      </div>

      <el-row v-loading="isLoading" :gutter="20">
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="8"
          v-for="(item, index) in list_teetime"
          :key="index"
        >
          <CardTee
            class="w-100"
            :object-data="item"
            :price="item.price"
            :price-discount="item.price_sale"
            :start-time="formattedTime(item.time_start)"
            :end-time="formattedTime(item.time_end)"
            :start-date="item.date_start"
            :end-date="item.date_end"
            :title="item?.facility_name"
            :image="item?.images"
            :facility-id="item.facility_id"
            :id="item?.id"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getBackGround } from "@/utils/wapAuth";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import CardTee from "../../../../components/wapV2/cards/CardTee.vue";
import CountDownTime from "@/views/components/wapV2/CountDownTime";
import TeeTimeResource from "@/views/api/wapV2/tee-time.js";
import { mapGetters, mapActions } from "vuex";
import HomeRequest from "@/views/api/wapV2/homepage.js";

export default {
  components: {
    MainNavBarWapV2,
    CardTee,
    CountDownTime
  },
  name: "list-teetime",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  created() {
    switch (+this.$route.query.type) {
      case 0:
        this.infoHeader.title = "Flash Sale";
        this.title = this.$t("wap.text144");
        break;
      case 1:
        this.infoHeader.title = this.$t("wap.text145");
        break;
      default:
        break;
    }
    this.title = this.$route.query.title;
    this.onGetListTeetime();
  },
  data() {
    return {
      bg: getBackGround(),
      infoHeader: {
        title: "Flash Sale",
        isShowHomeIcon: true
      },
      isLoading: false,
      title: "",
      name_count_down: "time1",
      query: this.$route.query
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["list_teetime"])
  },
  methods: {
    ...mapActions(["update_teetime"]),
    formattedTime(time) {
      const [hh, mm] = time.split(":");
      const formattedTime = `${hh}:${mm}`;
      return formattedTime;
    },
    async onGetListTeetime() {
      this.isLoading = true;
      const params = {
        flash_sale_id: this.query.flash_sale_id
      };
      const { error_code, data } = await TeeTimeResource.getListPaxByCategory(
        params
      );
      if (error_code != 0) {
        this.isLoading = false;
        return;
      }
      const ids = [...new Set(data.flatMap(item => item.facility_id))];
      const images = await this.getListImageFacility(ids);
      let mapData = [];
      if (images) {
        mapData = data.map(obj1 => {
          const match = images.find(obj2 => obj2.id === obj1.facility_id);
          if (match) {
            return { ...obj1, images: match.images[0] };
          }
        });
      }
      this.update_teetime(mapData);
      this.isLoading = false;
    },
    async getListImageFacility(ids) {
      try {
        const { error_code, data } = await HomeRequest.getImageFacility({
          ids
        });
        if (error_code === 0) {
          return data.map(i => ({ id: i.course_id, images: i.images }));
        }
        return null;
      } catch (error) {}
    }
  }
};
</script>

<style lang="scss" scoped>
.top-spacing {
  padding-top: 100px;
}
.full-width {
  width: 100%;
}
.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-h3 {
    font-size: 16px;
  }
  .top-post-container {
    background: #f0f0f0;
    border-left: 4px solid #111827;
    padding: 8px 15px;
    color: #111827;
    font-size: 16px;
    font-weight: 700;
  }
}
@media screen and (min-width: 0px) and (max-width: 480px) {
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
  .top-spacing1 {
    padding-top: 170px;
  }
  .title-h3 {
    font-size: 14px;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .title-section {
    display: none;
  }
}
</style>
